// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".m2ZQS{padding:5% 15%;-ms-flex-direction:row-reverse;flex-direction:row-reverse;-ms-flex-pack:justify;justify-content:space-between;-ms-flex-align:center;align-items:center;min-height:100vh}.m2ZQS,.m2ZQS div{display:-ms-flexbox;display:flex}.m2ZQS div{-ms-flex-direction:column;flex-direction:column;-ms-flex-align:start;align-items:flex-start;width:49%}._2cGAN{font-size:60px;color:#9b9b9b}._2cGAN,._2ZgY9{margin-bottom:25px}._2ZgY9{font-size:24px}a{text-decoration:none}@media only screen and (max-width:850px){._2ZgY9{font-size:20px!important}.m2ZQS{padding:5%;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center}.m2ZQS,.m2ZQS div{-ms-flex-align:center;align-items:center}.m2ZQS div{width:100%}._2cGAN{margin-top:30px}}", ""]);
// Exports
exports.locals = {
	"container": "m2ZQS",
	"code": "_2cGAN",
	"title": "_2ZgY9"
};
module.exports = exports;
